import {Injectable} from "@angular/core";
import {HttpService} from "../../../../services/http.service";

@Injectable()
export class ProcurementProcessFlowService {
    url = 'api/procurement-process';

    constructor(private httpService: HttpService) {}

    milestones(tenderRevisionId: number) {
        return this.httpService.get(`${this.url}/${tenderRevisionId}/milestones`);
    }
}